// extracted by mini-css-extract-plugin
module.exports = {"loading":"LazyArtworkList_loading__GwwGr","container":"LazyArtworkList_container__83Jvj","grid":"LazyArtworkList_grid__SfSQt"};